/**
 * Normalizes a city name for consistent storage and catalog filtering.
 *
 * Rules applied (in order):
 * 1. Trim leading/trailing whitespace
 * 2. Collapse internal whitespace runs to a single space
 * 3. Title Case each word (lowercase the rest, capitalize the letter after
 *    the start of the string or any non-alphanumeric character -- matches
 *    Postgres `initcap()` word-boundary semantics)
 *
 * NOT done (out of scope, risk of data corruption):
 * - Transliteration / diacritic normalization ('Wroclaw' -> 'Wrocław').
 *   Casing/whitespace variants and diacritic variants are different kinds of
 *   duplicates; deduplicating the latter requires a city alias dictionary,
 *   an explicit future follow-up (see CU-86cak7zg9).
 *
 * Returns '' for null/undefined/empty input.
 */
export function normalizeCityName(raw: string | null | undefined): string {
  if (!raw) return '';

  const collapsed = raw.trim().replace(/\s{2,}/g, ' ');
  if (!collapsed) return '';

  return collapsed
    .toLowerCase()
    .replace(
      /(^|[^\p{L}\p{N}])(\p{L})/gu,
      (_match, sep: string, letter: string) => sep + letter.toUpperCase(),
    );
}
